import React from "react";
import {
  DatePicker as AntdDatePicker,
  TimePicker as AntdTimePicker,
} from "antd";
import { Capacitor } from "@capacitor/core";

const isIos = Capacitor.getPlatform() === "ios";

// HOC for DatePicker with readOnly
export const DatePicker = props => {
  return <AntdDatePicker inputReadOnly={isIos} {...props} />;
};

// HOC for TimePicker with readOnly
export const TimePicker = props => {
  return <AntdTimePicker inputReadOnly={isIos} {...props} />;
};
